import { useEffect, useState } from "react";
import { getAllPaginatedActivities } from "../../API/Mediatheque/ActivityReports/activityService";
import Loader from "../../components/Loader/Loader";
import { Button } from "../../components/ui/button";
import { Card, CardTitle } from "../../components/ui/card";
import { useScrollToTop } from "../../hooks/hooks";
import icon from "../../images/icons/Design sans titre (44).png";
import pdfIcon from "../../images/icons/pdf.png";
import img from "../../images/installation_paysage.jpg";

const MediathequeActivityReport = () => {
  useScrollToTop();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({
    totalPages: 0,
    count: 0,
    activities: [],
  });

  const fetchData = async () => {
    setLoading(true);
    const response = await getAllPaginatedActivities(currentPage);
    if (response) {
      const { activities, totalPages, count } = response;
      setData({
        ...data,
        activities: activities,
        totalPages,
        count,
      });
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const openFile = (file: any) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/medias/reports/${encodeURIComponent(file)}`;

    window.open(fileUrl, "_blank");
  };

  const downloadFile = (file: string) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/medias/reports/${encodeURIComponent(file)}`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = file;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {"Médiathèque  "}
          </h1>

          <div className="flex justify-center mt-3">
            <p className="w-full text-white ">
              {"Toutes nos documentations à votre disposition"}
            </p>
          </div>
        </section>
      </div>
      <div className="container mx-auto mt-20 mb-20 md:px-72">
        <h1 className="text-2xl font-bold text-black">Rapport d'activités</h1>

        <div>
          {loading ? (
            <div className="flex justify-center">
              <Loader />
            </div>
          ) : data.totalCount === 0 ? (
            <div className="flex mt-2 space-x-2">
              <div>
                <img src={icon} alt="" />
              </div>
              <div>
                Nous n'avons pas d'offres d'emploi actuellement, mais n'hésitez
                pas à revenir plus tard ou à nous suivre pour être informé des
                prochaines opportunités
              </div>
            </div>
          ) : (
            <div className="mt-10">
              {data.activities.map((item: any) => (
                <Card className="p-5 mt-5 " key={item?.id}>
                  <CardTitle>
                    <div className="flex justify-start ml-5 ">
                      <div>
                        <img src={pdfIcon} alt="" className="w-20" />
                      </div>
                      <div className="flex flex-col items-start justify-center ">
                        <div></div>
                        <h1 className="ml-5 text-start">{item?.title}</h1>

                        <div className="flex mt-5 ml-5 space-x-5">
                          <div>
                            <Button
                              className="uppercase"
                              onClick={() => openFile(item.file)}
                            >
                              Voir le document
                            </Button>
                          </div>
                          <div>
                            <Button
                              className="uppercase"
                              onClick={() => downloadFile(item?.file)}
                            >
                              télécharger
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardTitle>
                </Card>
              ))}
            </div>
          )}
        </div>

        {!loading && data.totalPages > 1 && (
          <div className="flex justify-center mt-6 space-x-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className={`px-4 py-2 rounded ${
                currentPage === 1
                  ? "bg-gray-300"
                  : "bg-primary text-white hover:bg-primary-dark"
              }`}
            >
              Précédent
            </button>
            <span className="px-4 py-2 border rounded">
              {currentPage} / {data.totalPages}
            </span>
            <button
              disabled={currentPage === data.totalPages}
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, data.totalPages))
              }
              className={`px-4 py-2 rounded ${
                currentPage === data.totalPages
                  ? "bg-gray-300"
                  : "bg-primary text-white hover:bg-primary-dark"
              }`}
            >
              Suivant
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MediathequeActivityReport;
